import {isNil} from 'ramda';

import {GetAllEnumsResponse} from '../../../types/api/api';

type FeatureKey = GetAllEnumsResponse[number]['keys'][number];

/**
 * Returns the const_key of the root of the feature branch containing `constKey`
 * (the ancestor with no parent, or `constKey` if missing from `allKeys`).
 */
export function findRootKeyInFeatureTree(
  constKey: string,
  allKeys: GetAllEnumsResponse[number]['keys']
): string {
  const key = allKeys.find((f) => f.const_key === constKey);
  if (isNil(key) || isNil(key.parent)) {
    return constKey;
  }
  return findRootKeyInFeatureTree(key.parent, allKeys);
}

/**
 * `true` when `descendant` is a strict child (any depth) of `ancestor` in `allKeys`.
 */
export function isKeyDescendantOfInFeatureTree(
  descendant: string,
  ancestor: string,
  allKeys: FeatureKey[]
): boolean {
  if (descendant === ancestor) {
    return false;
  }
  const node = allKeys.find((f) => f.const_key === descendant);
  if (isNil(node) || isNil(node.parent)) {
    return false;
  }
  if (node.parent === ancestor) {
    return true;
  }
  return isKeyDescendantOfInFeatureTree(node.parent, ancestor, allKeys);
}
